/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import Room from './Room'
import UserPermission from './UserPermission'

/**
 * The ConfigusersPermissions model module.
 * @module model/ConfigusersPermissions
 * @version 1.0.0
 */
export default class ConfigusersPermissions {
  /**
   * Constructs a new <code>ConfigusersPermissions</code>.
   * @alias module:model/ConfigusersPermissions
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>ConfigusersPermissions</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ConfigusersPermissions} obj Optional instance to populate.
   * @return {module:model/ConfigusersPermissions} The populated <code>ConfigusersPermissions</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ConfigusersPermissions()

      if (data.hasOwnProperty('room')) {
        obj['room'] = Room.constructFromObject(data['room'])
      }
      if (data.hasOwnProperty('user_permission')) {
        obj['user_permission'] = UserPermission.constructFromObject(data['user_permission'])
      }
    }
    return obj
  }

  /**
   * @member {module:model/Room} room
   */
  room = undefined
  /**
   * @member {module:model/UserPermission} user_permission
   */
  user_permission = undefined
}
